import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import AxiosRequest from '../axiosComponent/allAxiosCommonRequest';
const MyBillingPartyBranch = ({
    field: { name, value, dataId },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        // console.log(props.id)
        AxiosRequest({
            url: `masters/billing_party_branch`,
            method: 'get',
            getValues: `billingPartyId=${props.id}&`
        }).then((response) => {
            // console.log('billing_party_branch', response.data.resultSet)
            if (response.data.resultSet && response.data.resultSet.length > 0) {
                // if (props.value != '') {
                //     setFieldValue(props.gst, response.data.resultSet[0].billingPartyBranchGst)
                //     setFieldValue(props.pan, response.data.resultSet[0].billingPartyBranchPan)
                // }
                setcontent(response.data.resultSet)
            }
            setloading(false)
        })
    }, [props.id])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.billingPartyBranchId
            temp.text = object.billingPartyBranchName
            temp.value = object.billingPartyBranchCode
            temp.extra = object
            return options[index] = temp
        })
    }

    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        let info = data.options
        if (info.length > 0) {
            let values = info.filter(args => args.value == data.value)
            setFieldValue(props.gst, values[0].extra.billingPartyBranchGst)
            setFieldValue(props.pan, values[0].extra.billingPartyBranchPan)
        }

    }

    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyBillingPartyBranch